import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitExibition`
//#region 基本信息
const GetList = (id: number) => `${apiUrl}/GetList/${id}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyData: UnitExibitionData = {
    Id: 0,
    UnitId: 0,
    ExibitionName: '',
    ExibitionDocId: 0,
    StartDate: new Date(),
    EndDate: new Date(),
    DocumentUnit: '',
    DisplayDescription: '',
    FundSoruceCountry: false,
    FundSoruceProvince: false,
    FundSoruceSelf: false,
    FundSoruce: '',
    FundAmount: 0,
    TempExibitionName: '',
    TempExibitionDocId: 0,
    TempStartDate: new Date(),
    TempEndDate: new Date(),
    TempDocumentUnit: '',
    TempDisplayDescription: '',
    TempFundSoruceCountry: false,
    TempFundSoruceProvince: false,
    TempFundSoruceSelf: false,
    TempFundSoruce: '',
    TempFundAmount: 0,
    ExibitionTypeInKind: false,
    ExibitionTypePicture: false,
    ExibitionTypeOther: false,
    ExibitionTypeOtherName: '',
    SecuritySituation: '',
    ExibitionTypeId: 0,
    ExibitionSpecification: '',
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    ExibitionDocNo: '',
    TempExibitionDocNo: '',
    ExibitionTypeName: '',
    UserName: '',

    AttachTypeProgram: 0,
    AttachGuidProgram: '',
    AttachTypeOutline: 0,
    AttachGuidOutline: '',
    AttachTypeTempProgram: 0,
    AttachGuidTempProgram: '',
    AttachTypeTempOutline: 0,
    AttachGuidTempOutline: '',
    AttachTypePicture: 0,
    AttachGuidPicture: ''
}
export interface UnitExibitionData {
    [key: string]: any
    Id: number
    UnitId: number
    ExibitionName: string
    ExibitionDocId: number
    StartDate: Date
    EndDate: Date
    DocumentUnit: string
    DisplayDescription: string
    FundSoruceCountry: boolean
    FundSoruceProvince: boolean
    FundSoruceSelf: boolean
    FundSoruce: string
    FundAmount: number
    TempExibitionName: string
    TempExibitionDocId: number
    TempStartDate: Date
    TempEndDate: Date
    TempDocumentUnit: string
    TempDisplayDescription: string
    TempFundSoruceCountry: boolean
    TempFundSoruceProvince: boolean
    TempFundSoruceSelf: boolean
    TempFundSoruce: string
    TempFundAmount: number
    ExibitionTypeInKind: boolean
    ExibitionTypePicture: boolean
    ExibitionTypeOther: boolean
    ExibitionTypeOtherName: string
    SecuritySituation: string
    ExibitionTypeId: number
    ExibitionSpecification: string
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    ExibitionDocNo: string
    TempExibitionDocNo: string
    ExibitionTypeName: string
    UserName: string

    //展出方案
    AttachTypeProgram: number
    AttachGuidProgram: string
    //展陈大纲 
    AttachTypeOutline: number
    AttachGuidOutline: string
    //临时展出方案 
    AttachTypeTempProgram: number
    AttachGuidTempProgram: string
    //临时展陈大纲 
    AttachTypeTempOutline: number
    AttachGuidTempOutline: string
    //展陈照片 
    AttachTypePicture: number
    AttachGuidPicture: string
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetList(unitId),
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const postData = (form: UnitExibitionData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitExibitionData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
